import type { ZoneLink } from '@/features/MusicZones/components/zonesNavigation';
import { Briefcase, Building2, CarFront, Clapperboard, Cpu, Heart, LayoutGrid, Layers, Palette, PawPrint, Plane, TreePine, Trophy, Users, Utensils, Wind } from '@music-vine/cadence/icons';
export const SV_ZONE_LINKS: ZoneLink[] = [{
  slug: 'featured',
  name: 'Featured',
  href: '/stock-video',
  icon: LayoutGrid
}, {
  slug: 'cinematic',
  name: 'Cinematic',
  href: '/stock-video/category/cinematic',
  icon: Clapperboard
}, {
  slug: 'lifestyle',
  name: 'Lifestyle',
  href: '/stock-video/category/lifestyle',
  icon: Heart
}, {
  slug: 'travel-tourism',
  name: 'Travel',
  href: '/stock-video/category/travel-tourism',
  icon: Plane
}, {
  slug: 'city-urban',
  name: 'City & urban',
  href: '/stock-video/category/city-urban',
  icon: Building2
}, {
  slug: 'nature',
  name: 'Nature',
  href: '/stock-video/category/nature',
  icon: TreePine
}, {
  slug: 'aerial',
  name: 'Aerial',
  href: '/stock-video/category/aerial',
  icon: Wind
}, {
  slug: 'people',
  name: 'People',
  href: '/stock-video/category/people',
  icon: Users
}, {
  slug: 'backgrounds-textures',
  name: 'Textures',
  href: '/stock-video/category/backgrounds-textures',
  icon: Layers
}, {
  slug: 'art',
  name: 'Art',
  href: '/stock-video/category/art',
  icon: Palette
}, {
  slug: 'food-drink',
  name: 'Food & drink',
  href: '/stock-video/category/food-drink',
  icon: Utensils
}, {
  slug: 'technology',
  name: 'Technology',
  href: '/stock-video/category/technology',
  icon: Cpu
}, {
  slug: 'sports',
  name: 'Sports',
  href: '/stock-video/category/sports',
  icon: Trophy
}, {
  slug: 'business',
  name: 'Business',
  href: '/stock-video/category/business',
  icon: Briefcase
}, {
  slug: 'transportation-vehicles',
  name: 'Vehicles',
  href: '/stock-video/category/transportation-vehicles',
  icon: CarFront
}, {
  slug: 'animals',
  name: 'Animals',
  href: '/stock-video/category/animals',
  icon: PawPrint
}];